import { render, staticRenderFns } from "./FullPageTemplate.vue?vue&type=template&id=18fb0314"
import script from "./FullPageTemplate.vue?vue&type=script&lang=js"
export * from "./FullPageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports